<template>
  <div class="market-price-overview-section mb-4">
    <div class="card border-0 shadow-sm mb-3" style="background: linear-gradient(135deg, #6f42c1, #8b5cf6);">
      <div class="card-body text-white">
        <div class="d-flex align-items-center">
          <i class="fas fa-chart-line me-2"></i>
          <h5 class="mb-0">{{ $t('dashboard.marketOverview.title') }}</h5>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <MarketPriceGauge
          :title="$t('dashboard.marketOverview.ddrMemoryMarket')"
          :adataPrice="ddrMemory.adata_average_price"
          :marketPrice="ddrMemory.market_average_price"
          :priceIndex="ddrMemory.price_index"
          :isCompetitive="ddrMemory.is_competitive"
          :recommendation="ddrMemory.recommendation"
        />
      </div>
      <div class="col-md-6 mb-3">
        <MarketPriceGauge
          :title="$t('dashboard.marketOverview.ssdStorageMarket')"
          :adataPrice="ssdStorage.adata_average_price"
          :marketPrice="ssdStorage.market_average_price"
          :priceIndex="ssdStorage.price_index"
          :isCompetitive="ssdStorage.is_competitive"
          :recommendation="ssdStorage.recommendation"
        />
      </div>
    </div>
    <AdataPricePositioning />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { getMarketPriceOverview } from '../api';
import MarketPriceGauge from './MarketPriceGauge.vue';
import AdataPricePositioning from './AdataPricePositioning.vue'; // Import the new component

export default {
  name: 'MarketPriceOverview',
  components: {
    MarketPriceGauge,
    AdataPricePositioning // Register the new component
  },
  setup() {
    const ddrMemory = ref({
      adata_average_price: 0,
      market_average_price: 0,
      price_index: 0,
      is_competitive: false,
      recommendation: '',
    });
    const ssdStorage = ref({
      adata_average_price: 0,
      market_average_price: 0,
      price_index: 0,
      is_competitive: false,
      recommendation: '',
    });

    const fetchMarketPriceOverview = async () => {
      try {
        const data = await getMarketPriceOverview();
        ddrMemory.value = data.ddr_memory || ddrMemory.value;
        ssdStorage.value = data.ssd_storage || ssdStorage.value;
      } catch (error) {
        console.error('Failed to fetch market price overview:', error);
        // Optionally set prices to an error state or default to 0
      }
    };

    // formatPrice is now handled within MarketPriceGauge.vue, so it's removed here.
    // If other parts of MarketPriceOverview still need it, it can be kept or moved to a utility.

    onMounted(() => {
      fetchMarketPriceOverview();
    });

    return {
      ddrMemory,
      ssdStorage,
      // formatPrice, // Removed as it's now in MarketPriceGauge
    };
  },
};
</script>

<style scoped>
</style>
